const KEY = 'peopleorbit_signed_in_before';

/**
 * Whether someone has signed in on this device (this browser, or this install of the phone app)
 * before. Decides where a signed-out visit to `/` goes: a first-time visitor sees sign-up, someone
 * who has been here before sees sign-in. Storage can be blocked or cleared; that only means the
 * visitor sees sign-up, which links to sign-in.
 */
export function hasSignedInBefore(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function markSignedIn(): void {
  try {
    localStorage.setItem(KEY, '1');
  } catch {
    // Storage unavailable: the next signed-out visit to `/` shows sign-up, with its sign-in link.
  }
}
